import { isNotFoundError } from "@homesite/hooks";
import { QueryClient } from "@tanstack/react-query";

export function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				staleTime: 30_000,
				// Never retry a genuine 404 — retrying a missing resource just
				// turns one failed request into three.
				retry: (failureCount, error) =>
					!isNotFoundError(error) && failureCount < 2,
				refetchOnWindowFocus: false,
			},
		},
	});
}
